import intl from 'react-intl-universal'
import { language, LanguageEnum } from '../utils/translation'



const locales = {
  [LanguageEnum.EN_US]: require('./en-US.json'),
  [LanguageEnum.AR_EG]: require('./ar-EG.json'),
  [LanguageEnum.MS_MY]: require('./ms-MY.json'),
  [LanguageEnum.AR_MA]: require('./ar-MA.json'),
  [LanguageEnum.AR_SA]: require('./ar-SA.json'),
  [LanguageEnum.CS_CZ]: require('./cs-CZ.json'),
  [LanguageEnum.DE_DE]: require('./de-DE.json'),
  [LanguageEnum.DZ_BT]: require('./dz-BT.json'),
  [LanguageEnum.ES_LA]: require('./es-419.json'),
  [LanguageEnum.ES_ES]: require('./es-ES.json'),
  [LanguageEnum.FR_FR]: require('./fr-FR.json'),
  [LanguageEnum.FR_MA]: require('./fr-MA.json'),
  [LanguageEnum.ID_ID]: require('./id-ID.json'),
  [LanguageEnum.IT_IT]: require('./it-IT.json'),
  [LanguageEnum.JA_JP]: require('./ja-JP.json'),
  [LanguageEnum.KM_KH]: require('./km-KH.json'),
  [LanguageEnum.KO_KR]: require('./ko-KR.json'),
  [LanguageEnum.MY_MM]: require('./my-MM.json'),
  [LanguageEnum.NL_NL]: require('./nl-NL.json'),
  [LanguageEnum.PL_PL]: require('./pl-PL.json'),
  [LanguageEnum.PT_PT]: require('./pt-PT.json'),
  [LanguageEnum.RO_RO]: require('./ro-RO.json'),
  [LanguageEnum.RU_RU]: require('./ru-RU.json'),
  [LanguageEnum.TH_TH]: require('./th-TH.json'),
  [LanguageEnum.TL_PH]: require('./tl-PH.json'),
  [LanguageEnum.TR_TR]: require('./tr-TR.json'),
  [LanguageEnum.UR_PK]: require('./ur-PK.json'),
  [LanguageEnum.VI_VN]: require('./vi-VN.json'),
  [LanguageEnum.ZH_HK]: require('./zh-HK.json'),
  [LanguageEnum.ZH_TW]: require('./zh-TW.json'),
  [LanguageEnum.ZH_CN]: require('./zh-CN.json'),
}

intl
  .init({
    currentLocale: language, // 设置初始语音
    locales,
  })
  .then(() => {
    console.log(`初始化完成（${language}）`)
  })
